// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "lazy-survey" + "." + "7a9871a9" + ".chunk.css";
};